// Создание нового проекта

import React, { useEffect, useState, useCallback } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import ProjectSections from "./components/ProjectSections";
import Files from "./components/Files";
import {
  setProjectAddMode,
  setProjectSectionAddMode,
} from "../Projects/actions";
import {
  clearProject,
  setProjectName,
  setProjectDescription,
  setProjectPriority,
  createProject,
  updateProject
} from "./actions";
import NameWithInput from "../../common/components/newComponent/Inputs/NameWithInput";
import CuratorsSelect from "./components/CuratorsSelect";
import CpeSelect from "./components/CpeSelect";
import { State } from "../../rootReducer";
import { getCanSend, getObservers } from "./selectors";
import Button from "../../common/components/newComponent/Buttons/Button";
import ChiefSelect from "./components/ChiefSelect";
import LeaderSelect from "./components/LeaderSelect";
import { User } from "../../common/types";
import ProjectSectionsForTask from "./components/ProjectSectionsForTask";
import ObserversSelect from "./components/ObserversSelect";
import useCheckRoles from "../../utils/hooks/useCheckRoles";
import { CheckContexts } from "../../common/constants/constants";

type Props = {
  name: string;
  projectSectionAddMode: boolean;
  description: string;
  priority_id: number;
  isSending: boolean;
  projectId: number;
  currentUserInfo: null | User;
  setProjectAddMode: (mode: boolean) => void;
  setProjectSectionAddMode: (mode: boolean) => void;
  setProjectName: (value: string) => void;
  setProjectDescription: (value: string) => void;
  clearProject: () => void;
  createProject: () => void;
  updateProject: () => void;
  projectObservers: number[]
};

const WrapperNewProject = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100vh;
  z-index: 1;
  flex-direction: column;
`;
const ModalBlockNewProject = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 15px rgba(41, 47, 76, 0.3);
  margin-top: 20px 0;
  transition: transform 0.3s ease;
  transform: ${({ isVisible }) =>
    isVisible ? "translateY(0vh)" : "translateY(-100vh)"};
  max-width: 530px;
  width: 100%;
  padding: 1.5rem 1rem;
  max-height: 100vh;
  overflow-y: auto;
`;

const NewProjectHeader = styled.div`
  span {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 24px;
    color: #212121;
  }
`;

const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1.25rem;
  align-items: center;
  transition: transform 0.3s ease;
  transform: ${({ isVisible }) =>
    isVisible ? "translateY(0vh)" : "translateY(-100vh)"};
  & > div {
    flex: 1;
  }
`;

const ProjectAddPannel: React.FC<Props> = ({
  name,
  description,
  isSending,
  projectId,
  currentUserInfo,
  setProjectAddMode,
  setProjectSectionAddMode,
  setProjectName,
  setProjectDescription,
  clearProject,
  createProject,
  updateProject,
  projectSectionAddMode,
}) => 
{
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const isUserCanSetObserver = useCheckRoles(CheckContexts.IS_USER_CAN_SET_PROJECT_OBSERVERS); 
  const isUserCanEditAndSaveProject = useCheckRoles(CheckContexts.IS_USER_CAN_EDIT_AND_SAVE_PROJECT, {projectId}); 

  useEffect(() => {
    setTimeout(setIsVisible, 0, true);
  }, [setIsVisible]);

  const closeHandler = useCallback(() => {
    setIsVisible(false);
    setTimeout(() => {
      setProjectAddMode(false);
      setProjectSectionAddMode(false);
      clearProject();
    }, 300);

  }, [clearProject, setProjectAddMode, setProjectSectionAddMode]);

  const saveHandler = useCallback(() => {
    if (projectId) {
      
      // Обновление проекта
      if(projectSectionAddMode) setProjectSectionAddMode(false);
      else updateProject();
      
    } else {
      createProject();
    }
  }, [createProject, projectId, updateProject]);

  return (
    <WrapperNewProject className='new-project-modal'>
      {projectSectionAddMode ? (
        <ModalBlockNewProject
          className="new-project-modal__section"
          isVisible={isVisible}
        >
         <NameWithInput
           disabled={!isUserCanEditAndSaveProject}
           title="Название раздела" 
           withoutIcon={true}
         > 
            <ProjectSectionsForTask closeHandler={closeHandler} saveHandler={saveHandler}/>
          </NameWithInput>
         <WrapperButtons isVisible={isVisible}>
            <Button
              onClick={closeHandler}
              design="secondary"
              title="Отмена"
              style={{ marginRight: ".5rem" }}
            />
      </WrapperButtons>
        </ModalBlockNewProject>
      ) : (
        <ModalBlockNewProject
          className="new-project-modal__project"
          isVisible={isVisible}
        >
          <NewProjectHeader>
            {/* Выводим предупреждение о важных полях, помеченных звездочкой- их надо заполнить, иначе не получится сохранить проект */}
            <span>
              {projectId
                ? "Редактирование (* - обязательные для заполнения поля) "
                : "Новый проект (* - обязательные для заполнения поля)"}
            </span>
          </NewProjectHeader>
          <NameWithInput
            title="Проект"
            type="textarea"
            inputValue={name}
            inputChangeHandler={setProjectName}
            necessarily
            disabled={!isUserCanEditAndSaveProject}
          />

          <NameWithInput
            title="Описание"
            type="textarea"
            inputValue={description}
            inputChangeHandler={setProjectDescription}
            disabled={!isUserCanEditAndSaveProject}
          />

          {/* Надо вывести предупреждение если нет пользователей в роли кураторов*/}
          <NameWithInput
            title="Куратор"
            iconName="people"
            inputName={"CuratorsSelect"}
            necessarily
            disabled={!isUserCanEditAndSaveProject}
          >
            <CuratorsSelect disabled={!isUserCanEditAndSaveProject} />
          </NameWithInput>
          {/* Надо вывести предупреждение если нет пользователей в роли руководителей проектов*/}
          <NameWithInput
            title="Рук. проекта"
            iconName="people"
            inputName={"CpeSelect"}
            necessarily
            disabled={!isUserCanEditAndSaveProject}
          >
            <CpeSelect disabled={!isUserCanEditAndSaveProject} />
          </NameWithInput>

          <NameWithInput
            title="Наблюдатели"
            iconName="people"
            inputName={"ObserversSelect"}
            disabled={!isUserCanEditAndSaveProject}
          >
            <ObserversSelect disabled={!isUserCanEditAndSaveProject || !isUserCanSetObserver}/>
          </NameWithInput>

          <NameWithInput
            title="Нач. отдела"
            iconName="people"
            inputName={"ChiefSelect"}
            disabled={!isUserCanEditAndSaveProject}
          >
            <ChiefSelect disabled={!isUserCanEditAndSaveProject} />
          </NameWithInput>

          <NameWithInput
            title="Рук. группы"
            iconName="people"
            inputName={"LeaderSelect"}
            disabled={!isUserCanEditAndSaveProject}
          >
            <LeaderSelect disabled={!isUserCanEditAndSaveProject} />
          </NameWithInput>

          <NameWithInput 
            title="Раздел" 
            iconName="folder"
            disabled={!isUserCanEditAndSaveProject}
          >
            <ProjectSections disabled={!isUserCanEditAndSaveProject} />
          </NameWithInput>

          <NameWithInput 
            title="Договор" 
            iconName="clip"
            disabled={!isUserCanEditAndSaveProject}
          >
            <Files disabled={!isUserCanEditAndSaveProject} />
          </NameWithInput>

          <WrapperButtons isVisible={isVisible}>
            <Button
              onClick={closeHandler}
              design="secondary"
              title="Отмена"
              style={{ marginRight: ".5rem" }}
            />
            <Button
              onClick={saveHandler}
              title={"Сохранить"}
              disabled={!isUserCanEditAndSaveProject}
              isSending={isSending}
            />
          </WrapperButtons>
        </ModalBlockNewProject>
      )}
    </WrapperNewProject>
  );
};

const mapStateToProps = (state: State) => {
  return {
    projectId: state.newProject.id,
    name: state.newProject.name,
    description: state.newProject.description,
    priority_id: state.newProject.priority_id,
    author_id: state.newProject.author_id,
    canSend: getCanSend(state),
    isSending: state.newProject.isSending,
    projectSectionAddMode: state.projectsPage.projectSectionAddMode,
    currentUserInfo: state.commonInfo.currentUserInfo,
    projectObservers: getObservers(state)
  };
};

const mapDispatchToProps = {
  setProjectAddMode,
  setProjectSectionAddMode,
  setProjectName,
  setProjectDescription,
  clearProject,
  setProjectPriority,
  createProject,
  updateProject
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectAddPannel);
